<template>
    <div class="picalendar">
        <b-modal no-close-on-backdrop title="New Meeting" class="modal-success" v-model="newMeetingDlg" ok-variant="success" :ok-only="false" ok-title="Close" size="lg"
            @ok="onSubmitMeeting">
            <b-container fluid>
                <b-card title="New meeting">
                    <b-form @submit.prevent="onSubmitTeam">
                        <b-container fluid class="dlg">
                            <b-row>
                                <b-col>
                                    <b-form-group id="input-group-1" label="Meeting title" label-for="input-title">
                                        <b-form-input id="input-title" v-model="newMeeting.title" type="text" />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="4">
                                    <b-form-group id="input-group-2" label="Date" label-for="input-start">
                                        <b-form-input id="input-start" v-model="newMeeting.date" type="date" />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="4">
                                    <b-form-group id="input-group-2" label="Start-End" label-for="input-start">
                                        <b-form-input id="input-start2" v-model="newMeeting.startT" type="time" />
                                        <b-form-input id="input-start2" v-model="newMeeting.endT" type="time" />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="4">
                                    <b-form-group id="input-group-3" label="Machine" label-for="input-code">
                                        <b-form-select id="input-code" v-model="newMeeting.machine" :options="availCodes" />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group id="input-group-4" label="People" label-for="input-people" v-if="newMeeting.machine>''">
                                        <multi-select :options="availUsers" :selected-options="newMeeting.people" @select="onMSelect"></multi-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group id="input-group-5" label="Description" label-for="input-desc">
                                        <b-form-textarea id="input-desc" v-model="newMeeting.description" />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-form>
                </b-card>
            </b-container>
        </b-modal>
        <b-container fluid>
            <b-row>
                <b-col cols="4">
                    <b-row><b-col>
                            <SchedaMacchina v-if="!!machine" :m="machine" :info="false" :key="machine.upd" />
                        </b-col></b-row>
                    <b-row><b-col>
                            <ExpiringIssues />
                        </b-col></b-row>
                    <b-row><b-col>
                            <OpenPointsStatus />
                        </b-col></b-row>
                    <!-- <b-row><b-col><vc-calendar is-expanded show-iso-weeknumbers /></b-col></b-row> -->

                </b-col>
                <b-col>
                    <div class="mycal">
                        <FullCalendar :options="calendarOptions">
                            <template v-slot:eventContent='arg'>
                                <b>{{ arg.event.title.split("§§")[0] }}</b>
                                <br>
                                {{ arg.event.title.split("§§")[1] }}
                            </template>
                        </FullCalendar>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import ExpiringIssues from '@/components/ExpiringIssues.vue'
import SchedaMacchina from "@/components/SchedaMacchina.vue";
import OpenPointsStatus from "@/components/OpenPointsStatus.vue";
import { MultiSelect } from "vue-search-select";
import 'vue-search-select/dist/VueSearchSelect.css'
import { API } from "@/api.js";
export default {
    components: {
        FullCalendar, // make the <FullCalendar> tag available
        ExpiringIssues,
        SchedaMacchina,
        OpenPointsStatus,
        MultiSelect
    },
    data: function () {
        return {
            events: [],
            firstclick: false,
            newMeetingDlg: false,
            newMeeting: {
                title: "",
                date: "",
                startT: "",
                endT: "",
                machine: "",
                people: [],
                description: ""
            },
            calendarOptions: {
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    interactionPlugin // needed for dateClick
                ],
                headerToolbar: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                },
                initialView: 'dayGridMonth',
                //initialEvents: this.events, //INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
                events: [], //INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
                editable: true,
                selectable: true,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                select: this.handleDateSelect,
                eventClick: this.handleEventClick,
                eventsSet: this.handleEvents,
                eventStartEditable: true, // no D&D
                // render: function (event, element) {
                //     console.log("eventRender", event, element)
                //     if (event.description != '' && typeof event.description !== "undefined") {
                //         element.find(".fc-title").append("<br/><b>" + event.description + "</b>");
                //     }
                // },
                /* you can update a remote database when these fire:
                eventAdd:
                eventRemove:
                */
               eventChange: this.eventChange,
            },
            currentEvents: [],
            availCodes: [],
            availUsers: []
        }
    },
    async mounted() {
        console.log("FullCalendar-machine", this.machine)
        this.availCodes = (await API.availCodes()).map(c => { return { value: c.code, text: c.code } });
        let mcode = this.machine ? this.machine.codice : null;
        let issues = (await API.prinIssues(this.machine ? this.machine.codice : null, this.section)).map(i => ({
                title: i.unit + "§§" + i.issue,
                start: i.ts,
                allDay: true
        }));
        let meetings = (await API.meetings(mcode, this.section)).map(m => ({
                title: `Meeting§§${m.title}`,
                start: m.starts,
                end: m.ends,
                allDay: false
        }));
        this.calendarOptions.events = issues.concat(meetings);
        this.$nextTick(async () => {
            if (this.machine)
                this.machine.image = "/images/units/" + this.machine.img;
        });
    },
    watch: {
        dlgCode: {
            handler: async function (val) {
                console.log("FullCalendar-machine", val)
                if(val>'') {
                    this.availUsers = (await API.getAvailUsers(val, true)).map(p => ({
                        value: p.id,
                        text: this.userName(p)
                    }));
                } else {
                    this.availUsers = [];
                }
            }
        }
    },
    computed: {
        dlgCode() {
            return this.newMeeting.machine;
        },
        section(){
            return this.$store.getters.section
        },
        machine(){
            return this.$store.getters.machine
        },
    },

    methods: {
        async onSubmitMeeting() {
            console.log("onSubmitMeeting", this.newMeeting)
            API.addMeeting(this.newMeeting.title, this.newMeeting.date, this.newMeeting.startT, this.newMeeting.endT, this.newMeeting.machine, this.newMeeting.people.map(p => p.value), this.newMeeting.description, this.section);
            this.newMeetingDlg = false;
        },
        handleWeekendsToggle() {
            this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
        },

        handleDateSelect(selectInfo) {
            // console.log("handleDateSelect", selectInfo)
            // let title = prompt('Please enter a new title for your event')
            // let calendarApi = selectInfo.view.calendar

            // calendarApi.unselect() // clear date selection

            // if (title) {
            //     calendarApi.addEvent({
            //         id: createEventId(),
            //         title,
            //         start: selectInfo.startStr,
            //         end: selectInfo.endStr,
            //         allDay: selectInfo.allDay
            //     })
            // }
            // gestisco il click intercettando un eventuale dblclick. Se è un click singolo faccio una cosa, altrimenti l'altra
            if(!this.firstclick) {
                this.firstclick = selectInfo;
                setTimeout(() => {
                    if(this.firstclick)
                        console.log("single click",this.firstclick)
                    this.firstclick = false;
                }, 300);
                return;
            } else {
                console.log("double click",this.firstclick)
                this.firstclick = false;
                this.newMeetingDlg = true;
            }
            
        },

        handleEventClick(clickInfo) {
            if (confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
                clickInfo.event.remove()
            }
        },

        handleEvents(events) {
            this.currentEvents = events
        },
        onMSelect(items) {
            console.log("ITEMS", items);
            this.newMeeting.people = items;
        },
        eventChange(event) {
            console.log("eventChange", event)
            // API.updateMeeting(event.event.id, event.event.title.split("§§")[1], event.event.start, event.event.end, event.event.allDay);
        }
    }
}

</script>
<style scoped>
div.mycal {
    background-color: white;
}
</style>
<style>
div.picalendar .fc-h-event .fc-event-main {
    overflow: hidden;
}

div.picalendar div.card {
    margin: 0px;
}
</style>
